// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QytKvOhL7ztPv00pqAp9 {
  padding: 0 6px;
  border-radius: 5px;
}

.qM46YDVJtux2lFsX9yrC {
  background-color: #e6f4e6;
  border: 1.5px solid #2e7d32;
  color: #2e7d32;
}

.QYv8c5hvevSxWVXwtz8L {
  background-color: #fff8e1;
  border: 1.5px solid #f9a825;
  color: #f57f17;
}

.V7Ts42p9GGc3qah7Ax7E {
  background-color: #fdecea;
  border: 1.5px solid #d32f2f;
  color: #d32f2f;
}

.lEu7ZH1VnyRMymz06NNX {
  background-color: #e3f2fd;
  border: 1.5px solid #1565c0;
  color: #1565c0;
}

.aNTtnTCPmatCbwDXyCTt {
  background-color: #f5f5f5;
  border: 1.5px solid #757575;
  color: #616161;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/components/badge/badge.module.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2BAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2BAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2BAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2BAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,2BAAA;EACA,cAAA;AAAF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.badge {\n  padding: 0 6px;\n  border-radius: 5px;\n}\n\n.success {\n  background-color: #e6f4e6;\n  border: 1.5px solid #2e7d32;\n  color: #2e7d32;\n}\n\n.warning {\n  background-color: #fff8e1;\n  border: 1.5px solid #f9a825;\n  color: #f57f17;\n}\n\n.danger {\n  background-color: #fdecea;\n  border: 1.5px solid #d32f2f;\n  color: #d32f2f;\n}\n\n.info {\n  background-color: #e3f2fd;\n  border: 1.5px solid #1565c0;\n  color: #1565c0;\n}\n\n.neutral {\n  background-color: #f5f5f5;\n  border: 1.5px solid #757575;\n  color: #616161;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `QytKvOhL7ztPv00pqAp9`,
	"success": `qM46YDVJtux2lFsX9yrC`,
	"warning": `QYv8c5hvevSxWVXwtz8L`,
	"danger": `V7Ts42p9GGc3qah7Ax7E`,
	"info": `lEu7ZH1VnyRMymz06NNX`,
	"neutral": `aNTtnTCPmatCbwDXyCTt`
};
export default ___CSS_LOADER_EXPORT___;
